import { useDispatch, useSelector } from 'react-redux'
import { useEffect, useMemo, useCallback } from 'react'
import { changeSelectedRatingType, getPromoAgentRating } from '#/src/redux/PromoAgentRating/actions'
import { getPromoRating as getPromoRatingSelector } from '#/src/redux/PromoAgentRating/selectors'
import {
  getCurrentPlaceFromRating,
  getCurrentRatingByRatingType,
  getRatingDescription,
  getSortedRatingTypes,
} from './utils'
import { RATING_CONFIG_BY_TYPE } from '#/src/containers/Filter/PromoRating/constants'

export const usePromoRating = () => {
  const dispatch = useDispatch();
  const { ratingLists, selectedRatingType, selectedRatingIndex, period } = useSelector(getPromoRatingSelector);

  const ratingTypes = useMemo(() => {
    if (!ratingLists?.length) {
      return [];
    }

    return getSortedRatingTypes(ratingLists);
  }, [ratingLists]);

  const ratingTypesOptions = useMemo(() => {
    return ratingTypes.map((ratingType) => (
      {
        key: ratingType,
        value: RATING_CONFIG_BY_TYPE[ratingType].ratingName,
      }
    ));
  }, [ratingTypes])

  useEffect(() => {
    dispatch(getPromoAgentRating());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const currentRating = useMemo(
    () => getCurrentRatingByRatingType({ ratingLists, selectedRatingType }),
    [ratingLists, selectedRatingType],
  );

  const currentPlace = useMemo(
    () => currentRating && getCurrentPlaceFromRating(currentRating),
    [currentRating],
  );

  const handleChangeSelectedRatingType = useCallback((_, selectedType, selectedIndex) => {
    dispatch(changeSelectedRatingType(selectedType, selectedIndex))
  }, []);

  const showSelectType = ratingLists?.length > 1

  // Проверки на selectedRatingType и currentPlace исключительно технические. Если их нет - контент вообще не отрисовывается
  const ratingDescription =
    selectedRatingType &&
    currentPlace &&
    getRatingDescription({ period, ratingType: selectedRatingType, currentPlace });

  return {
    currentRating,
    currentPlace,
    handleChangeSelectedRatingType,
    showSelectType,
    ratingDescription,
    ratingTypesOptions,
    selectedRatingIndex,
  }
}
